// extracted by mini-css-extract-plugin
export default {"modal":"UserModal_modal__nBuj+","modal-content":"UserModal_modal-content__ZOXs2","name":"UserModal_name__fPVrP","title":"UserModal_title__+G+p1","value":"UserModal_value__+RG-A"};